import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';

export interface Programs {
  id: string,
  title: string,
  location: string,
  content: string,
  whoSpeaking: string,
  dateOfStart: string,
  dateOfEnd: string
}

export interface State {
  programs:Programs[],
  loading:boolean
}


const defaultState: State = {
  programs:[],
  loading:false
};

const getters = {
  loading: (state: State) => state.loading,
  programs: (state: State) => state.programs,
}

const mutations: MutationTree<State> = {
  setPrograms(state: State, payload: Programs[]) {
    state.programs = payload
  },
  setOneProgram(state: State, payload: Programs) {
    state.programs.push(payload)
  },
  setLoadStatus(state: State, payload:boolean) {
    state.loading = payload
  },
  editOneProgram(state: State, payload:Programs) {
    const arr = state.programs.map((el)=>
    {
      if(el.id === payload.id){
        return payload
      } else {
        return el
      }
    })
   state.programs = JSON.parse(JSON.stringify(arr))
  },
  deleteProgram(state: State, payload: string) {
    if(state.programs){
      const arr:Programs[] = state.programs.filter((v:any) => v.id != payload)
      state.programs = arr
    }
  },
}

const actions: ActionTree<State, RootState> = {
  async loadProgramsFromServer({commit, state},payload:string) {
    commit('setLoadStatus', true)
    try {
      const {data} = await Vue.axios.get('/v4/show/' + payload + '/business-program?expand=isFavorite')
      if(data.error){
        throw (data.error)
      }
      commit('setPrograms', data.data)
      commit('setLoadStatus', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadStatus', false)
    }


  },
  async saveProgramFromServer({commit, state},payload:any){
    const show = payload.path
    let params = payload
    delete params.path
    try {
      const {data} = await axios.post('/v4/show/'+ show+'/business-program', params)
      commit('setOneProgram', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: ['Мероприятие добавлено']
      })
    }catch (e) {


    }
  },
  async editProgramFromServer({commit, state},payload:any){
    const id = payload.id
    let params = payload
    delete params.code
    try {
      const {data} = await axios.patch('/v4/show/business-program/'+id, params)
      commit('editOneProgram', data.data)
      this.commit('dialog/SetFullDialogShow', false)
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: ['Мепроприятие обновлено']
      })
    }catch (e) {


    }
  },
  async deleteProgramFromServer({commit, state},payload:string) {
    try {
      const {data} = await axios.delete('/v4/show/business-program/' + payload)
      if(data.data.status[0] === 'ok'){
        commit('deleteProgram', payload)
        this.commit('alerts/setAlert', {
          show: true,
          messages: ['Мероприятие удалено']
        })
      } else {
        throw(data)
      }
      return true
    } catch (e) {
      this.commit('alerts/setAlert',{
        show:true,
        color:'red',
        messages:[e.message]
      })
      return false
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
